import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

/**
 * Edit request is handled by the modal on My Requests index.
 * Redirect to index and pass editId in state so the modal can open for that request.
 */
export default function MyRequestEditPage() {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const numericId = id ? Number(id) : undefined
  useEffect(() => {
    navigate('/my-request', { replace: true, state: numericId && !Number.isNaN(numericId) ? { editId: numericId } : undefined })
  }, [navigate, numericId])
  return null
}
